import { Radio, RadioField } from '@ovotech/nebula';
import { useAtom } from 'jotai';
import { focusAtom } from 'jotai/optics';
import React from 'react';
import BackButton from '../components/back-button/BackButton';
import FormSection from '../components/form-section/FormSection';
import NextButton from '../components/next-button/NextButton';
import RadioSet from '../components/radio-set/RadioSet';
import StepCounter from '../components/step-counter/StepCounter';
import { stateAtom } from '../state';
import { NavigationProps } from './types';

const atom = focusAtom(stateAtom, (optic) => optic.prop('isDistanceMoreThanTenMeters'));

const MeterDistance: React.FC<NavigationProps> = ({ onBack, onNext }) => {
  const [state = false, setState] = useAtom(atom);

  return (
    <FormSection>
      <BackButton onClick={onBack} />
      <StepCounter />
      <RadioSet>
        <RadioField
          name="isDistanceMoreThanTenMeters"
          label="Please let us know roughly how far your gas meter is from the electricity meter."
          defaultValue={state ? 'true' : 'false'}
          onValueChange={(value) => setState(value === 'true')}
        >
          <Radio label="10 metres or less" id="false" value="false" />
          <Radio label="more than 10 metres" id="true" value="true" />
        </RadioField>
      </RadioSet>
      <NextButton onClick={onNext} trackOptions={['Meter distance entered']} />
    </FormSection>
  );
};

export default MeterDistance;
